import { createDomainError, VALIDATION_ERRORS } from './errors/index.js';
export async function queueEmail(queue, payload) {
    if (!payload?.to || !payload?.subject || (!payload?.html && !payload?.text)) {
        throw createDomainError(VALIDATION_ERRORS.INVALID_INPUT, { fields: ['to', 'subject', 'html', 'text'] }, 'Email payload requires to, subject, and html or text');
    }
    await queue.send(payload);
}
// Addresses pasted from chat apps and PDFs often carry zero-width joiners or a
// BOM. They survive trim(), and Postmark then rejects the whole send, so the
// invite is silently never delivered.
const INVISIBLE_CHARS = /[\u00ad\u200b-\u200f\u2060-\u2064\ufeff]/g;
export function normalizeEmail(email) {
    return email.replace(INVISIBLE_CHARS, '').trim().toLowerCase();
}
export function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
// ORCID sign-ins without a public email get a placeholder on a reserved domain
export const SYNTHETIC_EMAIL_DOMAIN = 'orcid.placeholder.invalid';
export function makeSyntheticEmail(orcidId) {
    return `${orcidId}@${SYNTHETIC_EMAIL_DOMAIN}`;
}
export function isSyntheticEmail(email) {
    return email.trim().toLowerCase().endsWith(`@${SYNTHETIC_EMAIL_DOMAIN}`);
}
// A verified real email is the account identity; providers only prove ownership
export function getOnboardingStep(user) {
    if (!user.email || isSyntheticEmail(user.email) || !user.emailVerified)
        return 'email';
    if (!user.profileCompletedAt)
        return 'profile';
    return null;
}
//# sourceMappingURL=email.js.map